import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { DEFAULT_BULK_ACTIONS_ASSIGN_TO_AGENT_MODAL_KEY } from '../../constants/modalKeys';
import { useBulkActionsHasError } from '../../hooks/useBulkActionsHasError';
import { useBulkActionsIsLoading } from '../../hooks/useBulkActionsIsLoading';
import { useBulkActionsOpenModal } from '../../hooks/useBulkActionsOpenModal';
import { useBulkActionsSelectionState } from '../../hooks/useBulkActionsSelectionState';
import { BaseBulkActionButton } from './BaseBulkActionButton';
import { CONTACT_TYPE_ID, COMPANY_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { SELECTION_METHOD_BY_QUERY } from '../../constants/selectionMethods';
import { jsx as _jsx } from "react/jsx-runtime";
const MAX_SELECTION_SIZE = {
  [CONTACT_TYPE_ID]: 25,
  [COMPANY_TYPE_ID]: 10
};
export function BulkAssignToAgentButton({
  hasAllScopes,
  modalProps
}) {
  const openModal = useBulkActionsOpenModal();
  const isLoading = useBulkActionsIsLoading();
  const hasError = useBulkActionsHasError();
  const {
    selectionIds,
    selectionObjectTypeId,
    selectionMethod
  } = useBulkActionsSelectionState();
  const enrollmentLimit = MAX_SELECTION_SIZE[selectionObjectTypeId];
  const disabled = isLoading || hasError || selectionMethod === SELECTION_METHOD_BY_QUERY || selectionIds && selectionIds.length > enrollmentLimit;
  const handleClick = useCallback(() => {
    openModal({
      modalKey: DEFAULT_BULK_ACTIONS_ASSIGN_TO_AGENT_MODAL_KEY,
      props: Object.assign({}, modalProps, {
        objectTypeId: selectionObjectTypeId
      })
    });
  }, [openModal, modalProps, selectionObjectTypeId]);
  if (!hasAllScopes || !hasAllScopes('prospecting-agent-access')) {
    return null;
  }
  const getDisabledTooltip = () => {
    if (selectionMethod === SELECTION_METHOD_BY_QUERY) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "bulkActions.buttonDisabledTooltips.assignToAgentGeneral"
      });
    } else {
      return selectionObjectTypeId === CONTACT_TYPE_ID ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "bulkActions.buttonDisabledTooltips.assignContactsToAgent",
        options: {
          enrollmentLimit
        }
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "bulkActions.buttonDisabledTooltips.assignCompaniesToAgent",
        options: {
          enrollmentLimit
        }
      });
    }
  };
  return /*#__PURE__*/_jsx(BaseBulkActionButton, {
    onClick: handleClick,
    icon: "artificialIntelligenceEnhanced",
    isLoading: false,
    disabled: disabled,
    disabledTooltip: getDisabledTooltip(),
    "data-selenium-test": "bulk-action-enroll-to-agent",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "bulkActions.buttonLabels.assignToAgent"
    })
  });
}